import { render, staticRenderFns } from "./WpProductListSlider.vue?vue&type=template&id=10869870"
import script from "./WpProductListSlider.vue?vue&type=script&lang=js"
export * from "./WpProductListSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports